import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React, { type JSX } from 'react';

import type { Receipt } from 'app-components/flux/receipts';

import ReceiptDetails from 'components/Receipts/ReceiptDetails';
import ReceiptFeedback from 'components/Receipts/ReceiptFeedback';
import useDetachReceipt from 'components/Receipts/useDetachReceipt';

type Props = {
  receipt: Receipt;
  open: boolean;
  onClose: () => void;
};

const ReceiptDetailsDialog = ({ receipt, open, onClose }: Props): JSX.Element => {
  const canDetach = Boolean(receipt.transactionId);
  const { confirmDetach, isDetaching } = useDetachReceipt(receipt, onClose, 'transaction-detail');

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography component='span' variant='titleMedium' noWrap>
          Expense receipt
        </Typography>
        <IconButton aria-label='Close receipt details' onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <ReceiptDetails receipt={receipt} />
        <ReceiptFeedback key={receipt.id} receipt={receipt} location='transaction-detail' />
      </DialogContent>
      {canDetach ? (
        <DialogActions sx={{ justifyContent: 'flex-start', px: 3, py: 2 }}>
          <Button
            color='error'
            variant='text'
            startIcon={<LinkOffRoundedIcon />}
            disabled={isDetaching}
            onClick={confirmDetach}
          >
            Detach receipt
          </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};

export default ReceiptDetailsDialog;
